import { useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { scrollToId } from "../../lib/scroll";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const [policy, setPolicy] = useState(null);
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-[#0a0a0b] pt-20 text-[#fafaf7]">
      <div className="wrap">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-center">
          <Logo />
          <div className="flex flex-wrap gap-6 text-sm text-white/60">
            {t.nav.map((n) => (
              <button key={n.id} data-testid={`footer-nav-${n.id}`} onClick={() => scrollToId(n.id)} className="transition-colors hover:text-[#e8c979]">{n.label}</button>
            ))}
          </div>
          <button data-testid="footer-back-to-top" onClick={() => scrollToId("top")} className="group flex items-center gap-3 text-sm text-white/60 hover:text-white">
            {f.top}
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors group-hover:border-[#d4af37]"><ArrowUp className="h-4 w-4" /></span>
          </button>
        </div>
        <div className="mt-14 border-t border-white/10 py-8 text-xs leading-relaxed text-white/40">
          <p data-testid="footer-legal">{f.legal}</p>
          <div className="mt-4 flex gap-6">
            <button data-testid="footer-privacy-link" onClick={() => setPolicy("privacy")} className="underline-offset-4 hover:text-[#e8c979] hover:underline">{f.privacy}</button>
            <button data-testid="footer-cookie-link" onClick={() => setPolicy("cookie")} className="underline-offset-4 hover:text-[#e8c979] hover:underline">{f.cookie}</button>
          </div>
        </div>
      </div>
      <div className="pointer-events-none select-none overflow-hidden">
        <p className="font-display -mb-[0.22em] whitespace-nowrap text-center text-[19vw] font-extrabold leading-none tracking-[-0.05em] text-white/[0.04]">BYTEVISION</p>
      </div>
      <Dialog open={!!policy} onOpenChange={(o) => !o && setPolicy(null)}>
        <DialogContent data-testid="policy-modal" className="rounded-[24px] border border-white/10 bg-[#0d0d0f] p-10 text-[#fafaf7] [&>button]:text-white/60">
          <DialogTitle className="font-display text-2xl font-bold">{policy === "cookie" ? f.cookie : f.privacy}</DialogTitle>
          <DialogDescription className="text-sm leading-relaxed text-white/60">{policy === "cookie" ? f.cookieText : f.privacyText}</DialogDescription>
        </DialogContent>
      </Dialog>
    </footer>
  );
};
